import { render, staticRenderFns } from "./BoardFormDialog.vue?vue&type=template&id=0879dde7&scoped=true"
import script from "./BoardFormDialog.vue?vue&type=script&lang=js"
export * from "./BoardFormDialog.vue?vue&type=script&lang=js"
import style0 from "./BoardFormDialog.vue?vue&type=style&index=0&id=0879dde7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0879dde7",
  null
  
)

export default component.exports